// extracted by mini-css-extract-plugin
export default {"flex-center":"facts_flex-center__q64P9","flex-vertical-center":"facts_flex-vertical-center__Y8yYN","facts":"facts_facts__B7WJb","content":"facts_content__CSdMM"};